/**
 * Created by mh on 2017/8/6.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import TimelineEventTableRowComponent from './TimelineEventTableRow';

@observer
class TimelineEventTable extends React.Component {
    render() {
        const { events } = this.props;

        return (
            <div className="table-responsive">
                <table className="table table-sm table-striped table-delivermedia">
                    <thead>
                        <tr>
                            <th>
                                <FormattedMessage id="Timelines.Thumbnail" defaultMessage="Thumbnail" />
                            </th>
                            <th>
                                <FormattedMessage id="Timelines.Type" defaultMessage="Type" />
                            </th>
                            <th>
                                <FormattedMessage id="Timelines.Time" defaultMessage="Time" />
                            </th>
                            <th>
                                <FormattedMessage id="Timelines.Duration" defaultMessage="Duration" />
                            </th>
                            <th>
                                <FormattedMessage id="Timelines.Description" defaultMessage="Description" />
                            </th>
                            <th>
                                <FormattedMessage id="Timelines.Actions" defaultMessage="Actions" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {events ?
                            events.map(event => <TimelineEventTableRowComponent event={event} key={event.id} />)
                            : (
                                <tr>
                                    <td>
                                        <FormattedMessage
                                            id="Timelines.NoTimelineFound"
                                            defaultMessage="No Timeline found" />
                                    </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>);
    }
}

TimelineEventTable.propTypes = {
    events: PropTypes.object.isRequired,
};

export default injectIntl(TimelineEventTable);
